export default __webpack_public_path__ + "static/minigap-8523496a2d144c9e63ff23a36adaaf31.png";